'use client'

import CookieBanner from './CookieBanner'
import CookieSettingsModal from './CookieSettingsModal'

/**
 * Renders the cookie consent UI (banner + settings modal).
 * Must be placed inside CookieConsentProvider.
 */
const CookieConsentUI = () => (
  <>
    <CookieBanner />
    <CookieSettingsModal />
  </>
)

export default CookieConsentUI
